import React from 'react';

import { Results } from 'src/types/ICollaborators'; 

import { TRBody } from './styles';

interface IProps {
  item: Results;
}

const GridItem = ({ item }: IProps) => {

  return (
    <TRBody>
      <td className='nowrap'>{item.fullName}</td>
      <td>{item.gpId}</td>
      <td>{item.level}</td>
      <td>{item.email}</td>
      <td>
        {item.hiringDate ? new Date(item?.hiringDate).toLocaleDateString('pt-BR', {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        }) : ''}
      </td>
    </TRBody>
  );
};

export default GridItem;
